<style scoped>
.no-wrap-word {
  white-space: normal !important;
  word-break: keep-all !important;
}
</style>

<template>
  <v-dialog
    :persistent="persistent || loading"
    :max-width="maxWidth"
    :value="value"
    @input="val => $emit('input', val)"
  >
    <v-card>
      <v-card-title class="subtitle-1 font-weight-light no-wrap-word">
        <slot>{{ title }}</slot>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="cancel-dialog-btn"
          :color="danger ? 'info' : 'error'"
          :disabled="loading"
          text
          @click="cancelHandler"
        >
          {{ cancelText }}
        </v-btn>

        <v-btn
          id="confirm-dialog-btn"
          :color="danger ? 'error' : 'info'"
          :loading="loading"
          text
          @click="confirmHandler"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AnchorConfirmDialog',
  props: {
    title: String,
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
    maxWidth: {
      type: [String, Number],
      default: 350,
    },
    danger: Boolean,
    persistent: Boolean,
    closeOnConfirm: {
      type: Boolean,
      default: true,
    },
    loading: Boolean,
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    open() {
      this.$emit('input', true);
    },
    cancelHandler() {
      this.$emit('input', false);
      this.$emit('cancel');
    },
    confirmHandler() {
      this.$emit('confirm');
      if (this.closeOnConfirm) {
        this.$emit('input', false);
      }
    },
  },
};
</script>
